var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H6C5.63886 20 5.28127 19.9289 4.94762 19.7907C4.61398 19.6525 4.31082 19.4499 4.05546 19.1945C3.8001 18.9392 3.59753 18.636 3.45933 18.3024C3.32113 17.9687 3.25 17.6111 3.25 17.25V11.25C3.25 11.0511 3.32902 10.8603 3.46967 10.7197C3.61032 10.579 3.80109 10.5 4 10.5C4.19891 10.5 4.38968 10.579 4.53033 10.7197C4.67098 10.8603 4.75 11.0511 4.75 11.25V17.25C4.746 17.4167 4.77538 17.5824 4.8364 17.7376C4.89742 17.8927 4.98886 18.0341 5.10534 18.1533C5.22181 18.2726 5.36097 18.3674 5.51461 18.4321C5.66826 18.4967 5.83329 18.53 6 18.53H18C18.3315 18.53 18.6495 18.3983 18.8839 18.1639C19.1183 17.9295 19.25 17.6115 19.25 17.28V11.28C19.25 11.0811 19.329 10.8903 19.4697 10.7497C19.6103 10.609 19.8011 10.53 20 10.53C20.1989 10.53 20.3897 10.609 20.5303 10.7497C20.671 10.8903 20.75 11.0811 20.75 11.28V17.28C20.7421 18.0041 20.4489 18.6959 19.934 19.2052C19.4191 19.7144 18.7242 20 18 20Z",
    fill: "url(#paint0_linear_297_10654)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 15.25C11.0923 15.2506 10.2156 14.9212 9.53307 14.3232C8.85051 13.7253 8.40861 12.8996 8.28972 12H3.99972C3.86512 12.001 3.73273 11.9658 3.61644 11.898C3.50015 11.8302 3.40425 11.7324 3.33879 11.6147C3.27333 11.4971 3.24074 11.3641 3.24442 11.2295C3.2481 11.095 3.28793 10.9639 3.35972 10.85L7.08973 4.85001C7.24287 4.58216 7.46641 4.36135 7.73612 4.21151C8.00582 4.06168 8.3114 3.98853 8.61972 4.00001H15.3797C15.7093 4.00092 16.0317 4.09539 16.3097 4.27242C16.5876 4.44945 16.8096 4.70177 16.9497 5.00001L20.6397 10.94C20.6903 11.051 20.7131 11.1727 20.7061 11.2944C20.6991 11.4162 20.6624 11.5344 20.5994 11.6389C20.5363 11.7433 20.4488 11.8308 20.3443 11.8937C20.2398 11.9566 20.1215 11.9931 19.9997 12H15.7097C15.5908 12.8996 15.1489 13.7253 14.4664 14.3232C13.7838 14.9212 12.9071 15.2506 11.9997 15.25ZM5.34972 10.53H8.99972C9.19864 10.53 9.3894 10.609 9.53005 10.7497C9.67071 10.8903 9.74972 11.0811 9.74972 11.28V11.5C9.74972 12.0967 9.98678 12.669 10.4087 13.091C10.8307 13.513 11.403 13.75 11.9997 13.75C12.5965 13.75 13.1688 13.513 13.5907 13.091C14.0127 12.669 14.2497 12.0967 14.2497 11.5V11.28C14.2497 11.0811 14.3287 10.8903 14.4694 10.7497C14.61 10.609 14.8008 10.53 14.9997 10.53H18.6497L15.6497 5.67001C15.5697 5.53001 15.4897 5.47001 15.3897 5.47001H8.61972C8.57249 5.47118 8.52639 5.48473 8.48603 5.50929C8.44567 5.53386 8.41246 5.56859 8.38973 5.61001L5.34972 10.53Z",
    fill: "url(#paint1_linear_297_10654)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_297_10654",
    x1: 3.25,
    y1: 10.5,
    x2: 23.7666,
    y2: 17.4609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E8AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_297_10654",
    x1: 3.24414,
    y1: 3.99884,
    x2: 24.3495,
    y2: 10.0323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E8AB0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/Mailbox.4052127cfff4afd7c373fa1825cf08d0.svg";
export { ForwardRef as ReactComponent };